import classNames from 'classnames';
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface Props {
	children: React.ReactNode;
	className?: string;
}

export default function CrudPageLayout({ children, className = '' }: Props) {
	const { pathname } = useLocation();

	useEffect(() => {
		const scrollContainer = document.querySelector('.body-content');
		if (scrollContainer) {
			scrollContainer.scrollTo(0, 0);
		} else {
			window.scrollTo(0, 0);
		}
	}, [pathname]);

	return <div className={classNames('min-h-screen bg-[#f8fafc] pb-20', className)}>{children}</div>;
}
